/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { configureStore, combineReducers } from "@reduxjs/toolkit";

/*============================================================
   REDUX PERSIST DEPENDENCIES
   1. persistReducer - When given a persist configuration & data slice
                       creats a persist reducer object

   2. persisStore - When give a slice & persist configuration
                    Creates a persistor object.
============================================================*/
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

/*============================================================
   IMPORTED DATA SLICES TO BE ADDED INTO REDUX STORE
============================================================*/
import slcApplication from "../states/slcApplication.js";
import slcPersonalInformation from "../states/slcPersonalInformation.js";
import slcObjectives from "../states/slcObjectives.js";
import slcIncomeExpense from "../states/slcIncomeExpense.js";
import slcAssetLiability from "../states/slcAssetLiability.js";
import slcInvestmentRisk from "../states/slcInvestmentRisk.js";
import slcCkaCkr from "../states/slcCkaCkr.js";
import slcAffordability from "../states/slcAffordability.js";
import slcProductRecommendation from "../states/slcProductRecommendation.js";

import { StaticDatePicker } from "@mui/x-date-pickers";
// import slcProtection from "../states/slcProtection.js";
// import slcWealthAccumulation from "../states/slcWealthAccumulation.js";

//CREATE A "PERSIST CONFIG"
const persistConfig = {
  key: "root",
  version: 1,
  storage, //Storage Engine (Eg. storageSession)
};

//CREATE "PERSIST REDUCER" FOR EACH DATA SLICE
// const persistReducerPersonalInformation = persistReducer(persistConfig, slcPersonalInformation);
// const persistReducerProtection = persistReducer(persistConfig, slcProtection);
// const persistReducerWealthAccumulation = persistReducer(persistConfig, slcWealthAccumulation);

//CREATE COMBINE REDUCERS
const allReducer = combineReducers({
  app: slcApplication,
  personalInformation: slcPersonalInformation,
  objectives: slcObjectives,
  incomeexpense: slcIncomeExpense,
  assetliability: slcAssetLiability,
  investmentRisk: slcInvestmentRisk,
  ckackr: slcCkaCkr,
  affordability: slcAffordability,
  productRecommendation: slcProductRecommendation,

  // protection: slcProtection,
  // wealthAccumulation: slcWealthAccumulation,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APPLICATION") state = undefined;
  return allReducer(state, action);
};

///CREATE PERSISTANT REDUCER
const persisted = persistReducer(persistConfig, rootReducer);

//CONFIGURE REDUX STORE (PERSISTANT)
export const store = configureStore({
  //MAP "PERSIST REDUCER" TO INTENDED REDUCER NAME
  //   personalInformation: persistReducerPersonalInformation,
  //   protection: persistReducerProtection,
  //   wealthAccumulation: persistReducerWealthAccumulation,

  reducer: persisted,

  //ADD MIDDLEWARE (can introduce non-serializable values during rehydration in the console.)
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
